module.exports = __webpack_public_path__ + "img/深蓝色.20f228ef.png";